/** @jsx jsx */
import { jsx } from '@compiled/react';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';
import {
	FloatingToolbarContainer,
	FloatingToolbarContent,
	FloatingToolbarSeparator,
	FloatingToolbarSideContent,
} from '../../common/ui';

type SkeletonBaseProps = {
	width: string;
};

const SkeletonBase = (props: SkeletonBaseProps) => (
	<Skeleton
		{...props}
		height="7px"
		isShimmering
		color={token('color.background.accent.gray.subtle')}
		ShimmeringEndColor={token('color.background.accent.gray.bolder')}
	/>
);

const SkeletonActionButton = (props: SkeletonBaseProps) => (
	<Box xcss={skeletonButtonStyles}>
		<SkeletonBase {...props} />
	</Box>
);

const SkeletonCloseIcon = () => (
	<Box xcss={closeIconContainerStyles}>
		<SkeletonBase width="16px" />
	</Box>
);

export const ToolbarSkeleton = () => (
	<FloatingToolbarContainer>
		<FloatingToolbarContent>
			<SkeletonCloseIcon />
			<FloatingToolbarSideContent>
				<SkeletonBase width="67px" />
			</FloatingToolbarSideContent>
			<FloatingToolbarSeparator />
			<Inline alignBlock="center">
				<SkeletonActionButton width="136px" />
				<SkeletonActionButton width="138px" />
			</Inline>
		</FloatingToolbarContent>
	</FloatingToolbarContainer>
);

const skeletonButtonStyles = xcss({
	paddingInlineStart: 'space.150',
	paddingInlineEnd: 'space.100',
});

const closeIconContainerStyles = xcss({
	paddingInlineStart: 'space.100',
	paddingInlineEnd: 'space.100',
});
